import { css } from 'styled-components';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import isObject from '@userzoomlibraries/toolkit-js-utils/is-object';
import isEmptyObject from '@userzoomlibraries/toolkit-js-utils/is-empty-object';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Combine multiple themes.
 *
 * @function
 * @param {object} [parameter={}] - Object with 'styles' and 'icons'.
 * @param {object[]} [parameter.styles=[]] - Array of styles of the themes.
 * @param {object[]} [parameter.icons=[]] - Array of icons of the themes.
 * @returns {object} Returns a new theme structure with combined styles and icons.
 * @example
 * const newTheme = combineThemes({ styles: [styles1, styles2], icons: [icons1, icons2] });
 * // => { styles: <NEW_COMBINED_STYLES>, icons: <NEW_COMBINED_ICONS> }
 */

var combineThemes = function combineThemes() {
  var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (isObject(parameter)) {
    var newStyles = {};
    var newIcons = {};
    var newBase = {};
    var newBreakpoints = {};
    var _parameter$styles = parameter.styles,
        styles = _parameter$styles === void 0 ? [] : _parameter$styles,
        _parameter$icons = parameter.icons,
        icons = _parameter$icons === void 0 ? [] : _parameter$icons,
        _parameter$base = parameter.base,
        base = _parameter$base === void 0 ? [] : _parameter$base,
        _parameter$breakpoint = parameter.breakpoints,
        breakpoints = _parameter$breakpoint === void 0 ? [] : _parameter$breakpoint;

    if (Array.isArray(styles) && styles.length > 0) {
      var purgedStyles = styles.filter(function (each) {
        return !!each;
      });
      var allKeys = purgedStyles.flatMap(function (theme) {
        return Object.keys(theme);
      });

      var distinctKeys = _toConsumableArray(new Set(allKeys));

      newStyles = distinctKeys.reduce(function (accumulator, currentValue) {
        return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, currentValue, css(["", ""], purgedStyles.map(function (theme) {
          return theme[currentValue];
        }))));
      }, {});
    }

    if (Array.isArray(styles) && styles.length > 0) {
      var _purgedStyles = styles.filter(function (each) {
        return !!each;
      });

      var _allKeys = _purgedStyles.flatMap(function (theme) {
        return Object.keys(theme);
      });

      var _distinctKeys = _toConsumableArray(new Set(_allKeys));

      newStyles = _distinctKeys.reduce(function (accumulator, currentValue) {
        return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, currentValue, css(["", ""], _purgedStyles.map(function (theme) {
          return theme[currentValue];
        }))));
      }, {});
    }

    if (Array.isArray(icons) && icons.length > 0) {
      var purgedIcons = icons.filter(function (each) {
        return !!each;
      });
      newIcons = purgedIcons.reduce(function (accumulator, currentValue) {
        var allKeys = Object.keys(currentValue);

        var distinctKeys = _toConsumableArray(new Set(allKeys));

        var partialNewIcons = distinctKeys.reduce(function (acc, current) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, currentValue[current]));
        }, {});
        return _objectSpread(_objectSpread({}, accumulator), partialNewIcons);
      }, {});
    }

    if (Array.isArray(base) && base.length > 0) {
      newBase = css(["", ""], base.map(function (eachBase) {
        return css(["", ""], eachBase);
      }));
    }

    if (Array.isArray(breakpoints) && breakpoints.length > 0) {
      var purgedBreakpoints = breakpoints.filter(function (each) {
        return !!each;
      }).filter(function (each) {
        return !isEmptyObject(each);
      });
      newBreakpoints = purgedBreakpoints.reduce(function (acc, current) {
        var breakpointKeys = Object.keys(current);
        var keys = breakpointKeys.reduce(function (insideAcc, insideCurrent) {
          var existKey = Object.keys(acc).some(function (each) {
            return each === insideCurrent;
          });

          if (!existKey) {
            return _objectSpread(_objectSpread({}, insideAcc), {}, _defineProperty({}, insideCurrent, current[insideCurrent]));
          }

          return _objectSpread(_objectSpread({}, insideAcc), {}, _defineProperty({}, insideCurrent, _objectSpread(_objectSpread(_objectSpread({}, insideAcc[insideCurrent]), current[insideCurrent]), {}, {
            dimensions: _objectSpread(_objectSpread({}, insideAcc[insideCurrent].dimensions), current[insideCurrent].dimensions)
          })));
        }, {});
        return _objectSpread(_objectSpread({}, acc), keys);
      }, {});
    }

    return {
      styles: newStyles,
      icons: newIcons,
      base: newBase,
      breakpoints: newBreakpoints
    };
  }

  throw new TypeError('Invalid type, Object type expected.');
};

combineThemes.HELPER_ID = 'Gearz.ThemeManager.combineThemes';
combineThemes.returnType = PropTypes.shapeWithDescription({
  styles: PropTypes.arrayOfWithDescription(PropTypes.object, 'Object with key/value with the styles by component id.'),
  icons: PropTypes.arrayOfWithDescription(PropTypes.object, 'Object with key/value with the icons by their names.'),
  base: PropTypes.oneOfTypeWithDescription([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)) // needed for css method of styled-components
  ], 'styled-component CSS object with the base styles.'),
  breakpoints: PropTypes.arrayOfWithDescription(PropTypes.shape({
    suffix: PropTypes.stringWithDescription('String used to identify the breakpoint. It will be used to generate the props by breakpoint.'),
    columns: PropTypes.numberWithDescription('Number of columns to be configured in the grid.'),
    rowGap: PropTypes.numberWithDescription('Separation (in pixels) of each row of the grid.'),
    columnGap: PropTypes.numberWithDescription('Separation (in pixels) of each column of the grid.'),
    dimensions: PropTypes.shapeWithDescription({
      from: PropTypes.number,
      to: PropTypes.number
    }, 'Object with from (minWidth) and to (maxWidth) dimensions (in pixels) of the breakpoint.')
  }), 'Array of breakpoints.')
}, 'Returns a new theme object with combined styles, icons and base.');
combineThemes.parameterTypes = {
  parameter: PropTypes.shapeWithDescription({
    styles: PropTypes.arrayOfWithDescription(PropTypes.object, 'Object with key/value with the styles by component id.'),
    icons: PropTypes.arrayOfWithDescription(PropTypes.object, 'Object with key/value with the icons by their names.'),
    base: PropTypes.oneOfTypeWithDescription([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)) // needed for css method of styled-components
    ], 'styled-component CSS object with the base styles.'),
    breakpoints: PropTypes.arrayOfWithDescription(PropTypes.arrayOf(PropTypes.shape({
      suffix: PropTypes.stringWithDescription('String used to identify the breakpoint. It will be used to generate the props by breakpoint.'),
      columns: PropTypes.numberWithDescription('Number of columns to be configured in the grid.'),
      rowGap: PropTypes.numberWithDescription('Separation (in pixels) of each row of the grid.'),
      columnGap: PropTypes.numberWithDescription('Separation (in pixels) of each column of the grid.'),
      dimensions: PropTypes.shapeWithDescription({
        from: PropTypes.number,
        to: PropTypes.number
      }, 'Object with from (minWidth) and to (maxWidth) dimensions (in pixels) of the breakpoint.')
    }), 'Array of breakpoints.'))
  }, 'Object with styles, icons, breakpoints and base styles to be combined.')
};
combineThemes.defaultParameters = {
  parameter: {
    styles: [],
    icons: [],
    base: '',
    breakpoints: []
  }
};

export { combineThemes as default };
